import React from "react";
import {IconActivity} from "@tabler/icons-react";
import {MiniCard} from "./MiniCard";
import {useDashboard} from "../../../../context/DashboardContext";

export const SpeechToTextCard = () => {
  const {responseTime} = useDashboard();

  const avgTranscribe = (
    responseTime?.filter(i => +i?.avgTranscribe > 0)
      ?.map(i => +i?.avgTranscribe)
      ?.reduce((prev, next) => prev + next, 0) /
    responseTime?.filter(i => +i?.avgTranscribe > 0)?.length
  )?.toFixed(2) || 0;

  const chartData = responseTime?.map(i => ({
    ...i,
    dateCreated: i?.hour,
    duration: i?.avgTranscribe?.toFixed(2)
  }));

  return (
    <MiniCard
      icon={IconActivity}
      color={"#ff2233"}
      title={`${avgTranscribe}s`}
      subtitle={"SPEECH TO TEXT"}
      data={chartData}
    />
  );
};
